import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    selected: [],
    selectedNames: []
};

export const channelsSelectedSlice = createSlice({
    name: 'channelsSelected',
    initialState: initialState,
    reducers: {
        edit: (state, payload) => {
            if(payload.payload === "default"){
                state = initialState;
            }
            else {
                state = {
                    ...state, 
                    ...payload.payload
                };
            }
            return state;
        }
    },
})

export const { edit } = channelsSelectedSlice.actions

export default channelsSelectedSlice.reducer